import { formatOptionPriceDelta } from '@/lib/products/option-price-delta';

/** Kleine prijsbadge onder een optiewaarde; groen als de waarde goedkoper is. */
export function OptionPriceDelta({ modifier, locale, className = '' }: { modifier: number; locale: string; className?: string }) {
  const text = formatOptionPriceDelta(modifier, locale);
  if (!text) return null;
  return (
    <span
      className={`inline-block whitespace-nowrap rounded-full px-1.5 py-0.5 text-[11px] font-semibold leading-none tabular-nums sm:text-xs ${
        modifier < 0 ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'
      } ${className}`}
    >
      {text}
    </span>
  );
}
